import config from "../../config";

export default function permissionGuard(Router, hasPermission) {
	Router.beforeEach((to, from, next) => {
		let routeRules = "public";
		const authorizedRoutes = [];
		const authorizedListingRoutes = [];

		if (to.meta && to.meta.rule) {
			routeRules = to.meta.rule;
		}

		if (Router.options && Router.options.routes) {
			const routes = Router.options.routes;

			routes.forEach(route => {
				if (route.meta && route.meta.rule) {
					const _routeRules = route.meta.rule;

					if (hasPermission(_routeRules)) {
						if (route.name) {
							authorizedRoutes.push(route.name);

							if (/listar$/.test(route.name)) {
								authorizedListingRoutes.push(route.name);
							}
						}
					}
				}
			});
		}

		if (hasPermission(routeRules) || to.name === "logout") {

			if (to.path === "/" && routeRules === "public") {
				return next({ name: "login" });
			}

			return next();
		}

		const iCanSeeHomePage = authorizedRoutes.includes(
			config.homePageRouteName
		);

		if (iCanSeeHomePage) {
			next({ name: config.homePageRouteName });
		} else if (authorizedListingRoutes.length) {
			next({ name: authorizedListingRoutes[0] });
		} else if (authorizedRoutes.length) {
			next({ name: authorizedRoutes[0] });
		} else {
			next({ name: "logout" });
		}
	});
}
